module.exports = "<div class=\"col-12\">\n  <h1 class=\"h1-responsive\">{{title}} List</h1>\n  <dac-asset-list [type]=\"assetType\" (selected)=\"viewAsset($event)\"></dac-asset-list>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/library-assets/exercise-list/exercise-list.component.html
// module id = ./src/app/library-assets/exercise-list/exercise-list.component.html
// module chunks = main